import { LoginResponseDto } from "@/data/dto/login-response-dto";
import { LoginRequestPayload } from "@/data/payload/login-request-payload";
import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

/**
 * 로그인 관련 API 요청을 담당하는 데이터 소스 클래스
 */
export class LoginSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  //MARK:- Login
  /**
   * 로그인 요청
   * @param {LoginRequestPayload} payload - 로그인에 필요한 정보(아이디, 비밀번호 등)
   * @returns {Promise<SATResult<LoginResponseDto, SATError>>} - 성공 시 LoginResponseDto, 실패 시 SATError
   */
  async login(payload: LoginRequestPayload): Promise<SATResult<LoginResponseDto, SATError>> {
    try {
      const response = await this.client.post(URLList.USER.LOGIN, payload);
      console.log("[LoginSource] :: login :: 로그인 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[LoginSource] :: login :: 로그인 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[LoginSource] :: login | ", satError);
      return SATResult.failure(satError);
    }
  }

  //MARK:- Logout
  /**
   * 로그아웃 요청
   * @returns {Promise<SATResult<void, SATError>>} - 성공 시 void, 실패 시 SATError
   */
  async logout(): Promise<SATResult<void, SATError>> {
    try {
      const response = await this.client.post(URLList.USER.LOGOUT);
      console.log("[LoginSource] :: logout :: 로그아웃 요청 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[LoginSource] :: logout :: 로그아웃 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[LoginSource] :: logout | ", satError);
      return SATResult.failure(satError);
    }
  }
}
